/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useCallback, useEffect } from 'react';

import PropTypes from 'prop-types';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import '@xengage/gw-platform-translations';
import _ from 'lodash';

// eslint-disable-next-line import/no-unresolved
import { MLGafUtil } from 'ml-portals-util-react';
import messages from './MLPaymentEmployeeDetailsComponent.messages';
import metadata from './MLPaymentEmployeeDetailsComponent.metadata.json5';
import styles from './MLPaymentEmployeeDetailsComponent.module.scss';


function MLPaymentEmployeeDetailsComponent(props) {
    const gafPathValue = 'baseData.gafInfo_ML.value';
    const { refreshData } = useDataRefresh();

    const {
        id,
        onValidate,
        showValidationErrors,
        gafInfoObject,
        submissionVM,
        isEndorsement,
        isPayrollDeductionSelected,
        updateWizardData
    } = props;

    const { onValidate: setComponentValidation, isComponentValid } = useValidation(id);
    const employeeInfoPath =_.get(submissionVM, 'baseData.employeeInfo_ML.value');
    const gafPathMl =_.get(submissionVM, 'baseData.gafInfo_ML');

    const {
        validateEmployeeNumberVisibility,
        validateDepartmentNumberVisibility,
        validateEmployeeDepartmentNumberVisibility,
        validateAlternateIdVisibility
    } = MLGafUtil();

    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid, id);
        }
    }, [id, onValidate, isComponentValid]);

    const writeValue = useCallback(
        (value, path) => {
            _.set(gafInfoObject.gafInfo, path, value);

            _.set(submissionVM, "baseData.gafInfo_ML", gafInfoObject.gafInfo);

            updateWizardData(submissionVM);
            refreshData();
        },
        [gafInfoObject.gafInfo, refreshData]
    );

    const resolvers = {
        resolveClassNameMap: styles
    };

    const overrides = {
        departmentNumberRow: {
            label: _.get(submissionVM, `${gafPathValue}.departmentNumberLiteral`, false) || messages.DepartmentNumber,
            visible: validateDepartmentNumberVisibility(gafPathMl, employeeInfoPath),
        },
        departmentNumber: {
            disabled: !!((!_.isEmpty(employeeInfoPath?.departmentNumber) && !_.isEmpty(employeeInfoPath?.name))),
        },
        employeeNumberRow: {
            label: _.get(submissionVM, `${gafPathValue}.employeeNumberLiteral`, false) || messages.EmployeeNumber,
            visible: validateEmployeeNumberVisibility(gafPathMl, employeeInfoPath),
        },
        employeeNumber: {
            disabled: !!((!_.isEmpty(employeeInfoPath?.employeeNumber) && !_.isEmpty(employeeInfoPath?.name)))
        },
        employeeDepartmentNumberRow: {  
            visible: validateEmployeeDepartmentNumberVisibility(gafPathMl, employeeInfoPath,true,isEndorsement,isPayrollDeductionSelected())
        },
        employeeDepartment: {
            label: _.get(submissionVM, `${gafPathValue}.alternateIdUsage`, false) ? 
                                        _.get(submissionVM, `${gafPathValue}.alternateEmployeeIdentifierLiteral`, false) || messages.EmployeeNumber 
                                        : _.get(submissionVM, `${gafPathValue}.employeeNumberLiteral`, false) || messages.EmployeeNumber,
            disabled: !!((!_.isEmpty(employeeInfoPath?.ssn) && !_.isEmpty(employeeInfoPath?.name)))
        },
        alternateIdRow: {
            label: _.get(submissionVM, `${gafPathValue}.alternateEmployeeIdentifierLiteral`, false) || messages.AlternateID,
            visible: validateAlternateIdVisibility(gafPathMl, employeeInfoPath,true,isEndorsement,isPayrollDeductionSelected())
        },
        alternateId: {
            disabled: !!((!_.isEmpty(employeeInfoPath?.ssn) && !_.isEmpty(employeeInfoPath?.name)))
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            model={gafInfoObject.gafInfo}
            onValidationChange={setComponentValidation}
            showErrors={showValidationErrors}
            onValueChange={writeValue}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

MLPaymentEmployeeDetailsComponent.propTypes = {
    id: PropTypes.string.isRequired,
    onValidate: PropTypes.func.isRequired,
    showValidationErrors: PropTypes.bool.isRequired,
    //
    gafInfoObject: PropTypes.shape({
        gafInfo: PropTypes.shape({
            departmentNumber: PropTypes.shape({
                value: PropTypes.string
            }),
            departmentNumberLiteral: PropTypes.shape({
                value: PropTypes.string
            }),
            employeeNumber: PropTypes.shape({
                value: PropTypes.string
            }),
            employeeNumberLiteral: PropTypes.shape({
                value: PropTypes.string
            }),
        }),
    }).isRequired
};

export default MLPaymentEmployeeDetailsComponent;